var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardPage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_12955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35906 0.0496587C1.81653 0.16266 1.09402 0.568827 0.755024 0.951391C0.599228 1.12718 0.364154 1.49845 0.232546 1.77639C0.0163258 2.23332 -0.00593063 2.38241 0.00105904 3.3298L0.00869322 4.37779L1.99385 10.8945C3.08571 14.4787 3.99271 17.5543 4.00954 17.7293L4.03999 18.0473L14.2946 18.0929C25.7129 18.1436 24.8007 18.088 25.4042 18.7692C26.0287 19.4739 26.0287 20.5393 25.4042 21.244C24.8007 21.9252 25.7129 21.8696 14.2946 21.9203L4.03999 21.9659L4.00954 22.2839C3.99271 22.4589 3.08571 25.5346 1.99385 29.1187L0.00869322 35.6354L0.00105904 36.6834C-0.00593063 37.6308 0.0163258 37.7799 0.232546 38.2368C0.57274 38.9554 0.977406 39.37 1.6669 39.7064C2.19269 39.9628 2.3598 39.9992 3.01554 40C3.46959 40.0006 3.97754 39.9374 4.3066 39.8393C4.60495 39.7505 12.3751 35.9487 21.5734 31.391C38.1919 23.1568 38.3013 23.1007 38.8801 22.5351C39.2336 22.1895 39.568 21.7511 39.7312 21.4191C39.9707 20.9319 40 20.7779 40 20.0066C40 19.2353 39.9707 19.0813 39.7312 18.5941C39.568 18.2621 39.2336 17.8237 38.8801 17.4781C38.3013 16.9125 38.1918 16.8563 21.5787 8.62482C12.3833 4.06859 4.63871 0.275753 4.36859 0.196196C3.73483 0.00974389 2.85772 -0.0542296 2.35906 0.0496587Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_12955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardPage);
export default __webpack_public_path__ + "static/media/icon-forward-page.1ac9db29bb08fbd3cb6ab0863df35862.svg";
export { ForwardRef as ReactComponent };